import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledLabel = styled.div`
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["500"])};
`;

export const StyledCompetitiveFilter = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 12px 12px 12px 24px;
`;

export const StyledCompetitiveFilterInner = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledChipWrap = styled.div`
    padding-left: 8px;
`;
